// this is generated via google sheet json export
export default {
  seoTitle: "College Basketball Picks - College Basketball Predictions and Analysis",
  news: {
    seoTitle: "College Basketball Sports Betting News | BetQL",
  },
  description:
    "Your source for college basketball picks every day. Check out the latest NCAA Basketball picks for every game with the best real-time line movement and value bets.",
  "free-pick-predictions": {
    seoTitle: "Free College Basketball Picks | College Basketball Predictions | BetQL",
    h1: "BetQL Free College Basketball Picks",
  },
  "best-bets": {
    seoTitle: "College Basketball Spreads | College Basketball Odds | BetQL",
    h1: "College Basketball Trending Bets",
    description:
      "Check out BetQL for the latest College Basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
  },
  odds: {
    seoTitle: "College Basketball Odds | College Basketball Lines | BetQL",
    h1: "College Basketball Model Bets for Today",
    description:
      "Check out BetQL for the latest College Basketball odds, lines, and spreads. Get the most updated odds, expert picks, and consensus picks from BetQL.",
    "first-half-lines": {
      seoTitle: "College Basketball First Half Lines | College Basketball 1st Half Odds | BetQL",
      h1: "College Basketball 1st Half Model Bets",
      description:
        "Check out BetQL for the latest College Basketball 1st half odds, lines, and spreads. Get the most updated odds, expert picks, and consensus picks from BetQL.",
      all: {
        seoTitle: "NCAAB Odds 1st Half Spread All Conferences | BetQL",
        h1: "All College Basketball 1st Half Model Bets",
        description:
          "Check out BetQL for the latest College Basketball 1st half odds, lines, and spreads. Get the most updated odds, expert picks, and consensus picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 1st Half Lines | BetQL",
        h1: "America East Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest America East basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 1st Half Lines | BetQL",
        h1: "AAC Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest American basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 1st Half Lines | BetQL",
        h1: "A10 Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest A10 basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 1st Half Lines | BetQL",
        h1: "ACC Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest ACC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 1st Half Lines | BetQL",
        h1: "ASUN Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 1st Half Lines | BetQL",
        h1: "Big 12 Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest BIG 12 basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 1st Half Lines | BetQL",
        h1: "Big East Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Big East basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 1st Half Lines | BetQL",
        h1: "Big Sky Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 1st Half Lines | BetQL",
        h1: "Big South Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Big South basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 1st Half Lines | BetQL",
        h1: "Big 10 Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Big basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 1st Half Lines | BetQL",
        h1: "Big West Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Big West basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 1st Half Lines | BetQL",
        h1: "Colonial Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 1st Half Lines | BetQL",
        h1: "CUSA Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 1st Half Lines | BetQL",
        h1: "Horizon League Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 1st Half Lines | BetQL",
        h1: "Ivy League Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 1st Half Lines | BetQL",
        h1: "MAC Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest MAC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 1st Half Lines | BetQL",
        h1: "MEAC Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 1st Half Lines | BetQL",
        h1: "Metro Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Metro basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 1st Half Lines | BetQL",
        h1: "MVC Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 1st Half Lines | BetQL",
        h1: "MW Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 1st Half Lines | BetQL",
        h1: "Northeast Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 1st Half Lines | BetQL",
        h1: "OVC Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 1st Half Lines | BetQL",
        h1: "Pac 12 Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 1st Half Lines | BetQL",
        h1: "Patriot League Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 1st Half Lines | BetQL",
        h1: "SEC Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest SEC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 1st Half Lines | BetQL",
        h1: "Southern Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Southern basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 1st Half Lines | BetQL",
        h1: "Southland Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Southland basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 1st Half Lines | BetQL",
        h1: "SWAC Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 1st Half Lines | BetQL",
        h1: "Summit Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Summit basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 1st Half Lines | BetQL",
        h1: "Sun Belt Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Odds 1st Half Spread Top 25 | BetQL",
        h1: "College Basketball Top 25 -1st Half Model Bets",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 1st Half Lines | BetQL",
        h1: "WAC Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest WAC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 1st Half Lines | BetQL",
        h1: "WCC Basketball - 1st Half Model Bets",
        description:
          "Check out BetQL for the latest WCC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    moneyline: {
      seoTitle: "College Basketball Money Lines | NCAAB Money Lines | BetQL",
      h1: "College Basketball Money Line Model Bets",
      description:
        "Check out BetQL for the latest College Basketball money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Money Lines - All Conferences | BetQL",
        h1: "All College Basketball Money Line Model Bets",
        description:
          "Check out BetQL for the latest College Basketball money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Money Lines | BetQL",
        h1: "America East Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest America East basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Money Lines | BetQL",
        h1: "AAC Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest American basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Money Lines | BetQL",
        h1: "A10 Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest A10 basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Money Lines | BetQL",
        h1: "ACC Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest ACC basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Money Lines | BetQL",
        h1: "ASUN Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest ASUN basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Money Lines | BetQL",
        h1: "Big 12 Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest BIG 12 basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Money Lines | BetQL",
        h1: "Big East Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big East basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Money Lines | BetQL",
        h1: "Big Sky Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big Sky basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Money Lines | BetQL",
        h1: "Big South Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big South basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Money Lines | BetQL",
        h1: "Big 10 Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Money Lines | BetQL",
        h1: "Big West Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big West basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Money Lines | BetQL",
        h1: "Colonial Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Colonial basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Money Lines | BetQL",
        h1: "CUSA Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest CUSA basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Money Lines | BetQL",
        h1: "Horizon League Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Horizon League basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Money Lines | BetQL",
        h1: "Ivy League Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Ivy League basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Money Lines | BetQL",
        h1: "MAC Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest MAC basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Money Lines | BetQL",
        h1: "MEAC Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest MEAC basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Money Lines | BetQL",
        h1: "Metro Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Metro basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Money Lines | BetQL",
        h1: "MVC Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Missouri Valley basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Money Lines | BetQL",
        h1: "MW Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Mountain West basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Money Lines | BetQL",
        h1: "Northeast Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Northeast basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Money Lines | BetQL",
        h1: "OVC Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Ohio Valley basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Money Lines | BetQL",
        h1: "Pac 12 Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest PAC 12 basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Money Lines | BetQL",
        h1: "Patriot League Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Patriot League basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Money Lines | BetQL",
        h1: "SEC Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest SEC basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Money Lines | BetQL",
        h1: "Southern Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Southern basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Money Lines | BetQL",
        h1: "Southland Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Southland basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Money Lines | BetQL",
        h1: "SWAC Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest SWAC basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Money Lines | BetQL",
        h1: "Summit Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Summit basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Money Lines | BetQL",
        h1: "Sun Belt Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Odds Moneyline Top 25 | BetQL",
        h1: "College Basketball Top 25 - Money Line Model Bets",
        description:
          "Check out BetQL for the latest Top 25 basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Money Lines | BetQL",
        h1: "WAC Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest WAC basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Money Lines | BetQL",
        h1: "WCC Basketball - Money Line Model Bets",
        description:
          "Check out BetQL for the latest WCC basketball odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-lines": {
      seoTitle: "College Basketball 2nd Half Lines | College Basketball 2nd Half Odds | BetQL",
      h1: "College Basketball 2nd Half Model Bets",
      description:
        "Check out BetQL for the latest College Basketball 2nd half odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "College Basketball 2nd Half Lines - All | BetQL",
        h1: "All College Basketball 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest College Basketball 2nd half odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 2nd Half Lines | BetQL",
        h1: "America East Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest America East basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 2nd Half Lines | BetQL",
        h1: "AAC Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest American basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 2nd Half Lines | BetQL",
        h1: "A10 Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest A10 basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 2nd Half Lines | BetQL",
        h1: "ACC Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest ACC basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 2nd Half Lines | BetQL",
        h1: "ASUN Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest ASUN basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 2nd Half Lines | BetQL",
        h1: "Big 12 Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest BIG 12 basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 2nd Half Lines | BetQL",
        h1: "Big East Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Big East basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 2nd Half Lines | BetQL",
        h1: "Big Sky Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Big Sky basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 2nd Half Lines | BetQL",
        h1: "Big South Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Big South basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 2nd Half Lines | BetQL",
        h1: "Big 10 Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Big basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 2nd Half Lines | BetQL",
        h1: "Big West Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Big West basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 2nd Half Lines | BetQL",
        h1: "Colonial Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Colonial basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 2nd Half Lines | BetQL",
        h1: "CUSA Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest CUSA basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 2nd Half Lines | BetQL",
        h1: "Horizon League Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Horizon League basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 2nd Half Lines | BetQL",
        h1: "Ivy League Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Ivy League basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 2nd Half Lines | BetQL",
        h1: "MAC Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest MAC basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 2nd Half Lines | BetQL",
        h1: "MEAC Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest MEAC basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 2nd Half Lines | BetQL",
        h1: "Metro Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Metro basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 2nd Half Lines | BetQL",
        h1: "MVC Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 2nd Half Lines | BetQL",
        h1: "MW Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Mountain West basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 2nd Half Lines | BetQL",
        h1: "Northeast Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Northeast basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 2nd Half Lines | BetQL",
        h1: "OVC Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 2nd Half Lines | BetQL",
        h1: "Pac 12 Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest PAC 12 basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 2nd Half Lines | BetQL",
        h1: "Patriot League Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Patriot League basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 2nd Half Lines | BetQL",
        h1: "SEC Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest SEC basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 2nd Half Lines | BetQL",
        h1: "Southern Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Southern basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 2nd Half Lines | BetQL",
        h1: "Southland Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Southland basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 2nd Half Lines | BetQL",
        h1: "SWAC Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest SWAC basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 2nd Half Lines | BetQL",
        h1: "Summit Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Summit basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 2nd Half Lines | BetQL",
        h1: "Sun Belt Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Odds 2nd Half Spread Top 25 | BetQL",
        h1: "College Basketball Top 25 - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest Top 25 basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 2nd Half Lines | BetQL",
        h1: "WAC Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest WAC basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 2nd Half Lines | BetQL",
        h1: "WCC Basketball - 2nd Half Model Bets",
        description:
          "Check out BetQL for the latest WCC basketball 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "totals-spread": {
      seoTitle: "College Basketball Over Unders | NCAAB Over Under Picks | BetQL",
      h1: "College Basketball Over Under Picks",
      description:
        "Check out BetQL for the latest College Basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "College Basketball Over Unders - All | BetQL",
        h1: "All College Basketball Over Under Picks",
        description:
          "Check out BetQL for the latest College Basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Over Unders | BetQL",
        h1: "America East Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest America East basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Over Unders | BetQL",
        h1: "AAC Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest American basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Over Unders | BetQL",
        h1: "A10 Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest A10 basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Over Unders | BetQL",
        h1: "ACC Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest ACC basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Over Unders | BetQL",
        h1: "ASUN Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest ASUN basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Over Unders | BetQL",
        h1: "Big 12 Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Over Unders | BetQL",
        h1: "Big East Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Big East basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Over Unders | BetQL",
        h1: "Big Sky Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Over Unders | BetQL",
        h1: "Big South Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Big South basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Over Unders | BetQL",
        h1: "Big 10 Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Big basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Over Unders | BetQL",
        h1: "Big West Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Big West basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Over Unders | BetQL",
        h1: "Colonial Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Colonial basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Over Unders | BetQL",
        h1: "CUSA Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest CUSA basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Over Unders | BetQL",
        h1: "Horizon League Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Over Unders | BetQL",
        h1: "Ivy League Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Over Unders | BetQL",
        h1: "MAC Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest MAC basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Over Unders | BetQL",
        h1: "MEAC Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest MEAC basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Over Unders | BetQL",
        h1: "Metro Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Metro basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Over Unders | BetQL",
        h1: "MVC Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Over Unders | BetQL",
        h1: "MW Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Over Unders | BetQL",
        h1: "Northeast Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Northeast basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Over Unders | BetQL",
        h1: "OVC Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Over Unders | BetQL",
        h1: "Pac 12 Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Over Unders | BetQL",
        h1: "Patriot League Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Over Unders | BetQL",
        h1: "SEC Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest SEC basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Over Unders | BetQL",
        h1: "Southern Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Southern basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Over Unders | BetQL",
        h1: "Southland Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Southland basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Over Unders | BetQL",
        h1: "SWAC Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest SWAC basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Over Unders | BetQL",
        h1: "Summit League Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Summit basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Over Unders | BetQL",
        h1: "Sun Belt Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Odds Total Top 25 | BetQL",
        h1: "College Basketball Top 25 - Over Under Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Over Unders | BetQL",
        h1: "WAC Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest WAC basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Over Unders | BetQL",
        h1: "WCC Basketball - Over Under Picks",
        description:
          "Check out BetQL for the latest WCC basketball over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-moneyline": {
      seoTitle: "College Basketball 1st Half Money Lines | BetQL",
      h1: "College Basketball 1st Half Money Line Model Bets",
      description:
        "Check out BetQL for the latest College Basketball 1st half money line odds. Get the most updated odds, expert picks, and consensus picks from BetQL.",
      all: {
        seoTitle: "NCAAB Odds 1st Half Moneyline All Conferences | BetQL",
        h1: "All College Basketball 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest College Basketball 1st half money line odds. Get the most updated odds, expert picks, and consensus picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 1st Half Moneylines | BetQL",
        h1: "America East Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest America East basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 1st Half Moneylines | BetQL",
        h1: "AAC Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest American basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 1st Half Money Lines | BetQL",
        h1: "A10 Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest A10 basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 1st Half Money Lines | BetQL",
        h1: "ACC Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest ACC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 1st Half Money Lines | BetQL",
        h1: "ASUN Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 1st Half Money Lines | BetQL",
        h1: "Big 12 Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest BIG 12 basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 1st Half Money Lines | BetQL",
        h1: "Big East Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big East basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 1st Half Money Lines | BetQL",
        h1: "Big Sky Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 1st Half Money Lines | BetQL",
        h1: "Big South Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big South basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 1st Half Money Lines | BetQL",
        h1: "Big 10 Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 1st Half Money Lines | BetQL",
        h1: "Big West Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big West basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 1st Half Money Lines | BetQL",
        h1: "Colonial Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 1st Half Money Lines | BetQL",
        h1: "CUSA Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 1st Half Money Lines | BetQL",
        h1: "Horizon League Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 1st Half Money Lines | BetQL",
        h1: "Ivy League Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 1st Half Money Lines | BetQL",
        h1: "MAC Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest MAC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 1st Half Money Lines | BetQL",
        h1: "MEAC Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 1st Half Money Lines | BetQL",
        h1: "Metro Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Metro basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 1st Half Money Lines | BetQL",
        h1: "MVC Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 1st Half Money Lines | BetQL",
        h1: "MW Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 1st Half Money Lines | BetQL",
        h1: "Northeast Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 1st Half Money Lines | BetQL",
        h1: "OVC Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 1st Half Money Lines | BetQL",
        h1: "Pac 12 Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 1st Half Money Lines | BetQL",
        h1: "Patriot League Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 1st Half Money Lines | BetQL",
        h1: "SEC Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest SEC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 1st Half Money Lines | BetQL",
        h1: "Southern Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Southern basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 1st Half Money Lines | BetQL",
        h1: "Southland Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Southland basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 1st Half Money Lines | BetQL",
        h1: "SWAC Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 1st Half Money Lines | BetQL",
        h1: "Summit Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Summit basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 1st Half Money Lines | BetQL",
        h1: "Sun Belt Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Odds 1st Half Money Line Top 25 | BetQL",
        h1: "College Basketball Top 25 - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 1st Half Money Lines | BetQL",
        h1: "WAC Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest WAC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 1st Half Money Lines | BetQL",
        h1: "WCC Basketball - 1st Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest WCC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-totals-spread": {
      seoTitle: "College Basketball 1st Half Over Unders | BetQL",
      h1: "College Basketball 1st Half Over Under Model Bets",
      description:
        "Check out BetQL for the latest College Basketball 1st half over under odds. Get the most updated odds, expert picks, and consensus picks from BetQL.",
      all: {
        seoTitle: "College Basketball 1st Half Over Unders All | BetQL",
        h1: "All College Basketball 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest College Basketball 1st half over under odds. Get the most updated odds, expert picks, and consensus picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East 1st Half Over Unders | BetQL",
        h1: "America East Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest America East basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference 1st Half Over Unders | BetQL",
        h1: "AAC Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest American basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 1st Half Over Unders | BetQL",
        h1: "A10 Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest A10 basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC 1st Half Over Unders | BetQL",
        h1: "ACC Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest ACC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN 1st Half Over Unders | BetQL",
        h1: "ASUN Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 1st Half Over Unders | BetQL",
        h1: "Big 12 Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest BIG 12 basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East 1st Half Over Unders | BetQL",
        h1: "Big East Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Big East basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky 1st Half Over Unders | BetQL",
        h1: "Big Sky Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South 1st Half Over Unders | BetQL",
        h1: "Big South Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Big South basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big Ten 1st Half Over Unders | BetQL",
        h1: "Big 10 Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Big basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West 1st Half Over Unders | BetQL",
        h1: "Big West Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Big West basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial 1st Half Over Unders | BetQL",
        h1: "Colonial Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA 1st Half Over Unders | BetQL",
        h1: "CUSA Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League 1st Half Over Unders | BetQL",
        h1: "Horizon League Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League 1st Half Over Unders | BetQL",
        h1: "Ivy League Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC 1st Half Over Unders | BetQL",
        h1: "MAC Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest MAC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC 1st Half Over Unders | BetQL",
        h1: "MEAC Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "Metro 1st Half Over Unders | BetQL",
        h1: "Metro Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Metro basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley 1st Half Over Unders | BetQL",
        h1: "MVC Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Moutain West 1st Half Over Unders | BetQL",
        h1: "MW Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast 1st Half Over Unders | BetQL",
        h1: "Northeast Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley 1st Half Over Unders | BetQL",
        h1: "OVC Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 1st Half Over Unders | BetQL",
        h1: "Pac 12 Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League 1st Half Over Unders | BetQL",
        h1: "Patriot League Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC 1st Half Over Unders | BetQL",
        h1: "SEC Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest SEC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "Southern Conference 1st Half Over Unders | BetQL",
        h1: "Southern Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Southern basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland 1st Half Over Unders | BetQL",
        h1: "Southland Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Southland basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "Southwestern Athletic 1st Half Over Unders | BetQL",
        h1: "SWAC Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League 1st Half Over Unders | BetQL",
        h1: "Summit Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Summit basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt 1st Half Over Unders | BetQL",
        h1: "Sun Belt Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "Top 25 1st Half Over Unders | BetQL",
        h1: "College Basketball Top 25 - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC 1st Half Over Unders | BetQL",
        h1: "WAC Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest WAC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "West Coast Conference 1st Half Over Unders | BetQL",
        h1: "WCC Basketball - 1st Half Over Under Model Bets",
        description:
          "Check out BetQL for the latest WCC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-moneylines": {
      seoTitle: "College Basketball 2nd Half Money Lines | BetQL",
      h1: "College Basketball 2nd Half Money Line Model Bets",
      description:
        "Check out BetQL for the latest College Basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Odds 2nd Half Moneyline All Conferences | BetQL",
        h1: "All College Basketball 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest College Basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 2nd Half Money Lines | BetQL",
        h1: "America East Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest America East basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 2nd Half Money Lines | BetQL",
        h1: "AAC Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest American basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 2nd Half Money Lines | BetQL",
        h1: "A10 Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest A10 basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 2nd Half Money Lines | BetQL",
        h1: "ACC Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest ACC basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 2nd Half Money Lines | BetQL",
        h1: "ASUN Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest ASUN basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 2nd Half Money Lines | BetQL",
        h1: "Big 12 Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest BIG 12 basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 2nd Half Money Lines | BetQL",
        h1: "Big East Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big East basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 2nd Half Money Lines | BetQL",
        h1: "Big Sky Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big Sky basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 2nd Half Money Lines | BetQL",
        h1: "Big South Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big South basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 2nd Half Money Lines | BetQL",
        h1: "Big 10 Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 2nd Half Money Lines | BetQL",
        h1: "Big West Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Big West basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 2nd Half Money Lines | BetQL",
        h1: "Colonial Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Colonial basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 2nd Half Money Lines | BetQL",
        h1: "CUSA Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest CUSA basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 2nd Half Money Lines | BetQL",
        h1: "Horizon League Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Horizon League basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 2nd Half Money Lines | BetQL",
        h1: "Ivy League Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Ivy League basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 2nd Half Money Lines | BetQL",
        h1: "MAC Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest MAC basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 2nd Half Money Lines | BetQL",
        h1: "MEAC Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest MEAC basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 2nd Half Money Lines | BetQL",
        h1: "Metro Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Metro basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 2nd Half Money Lines | BetQL",
        h1: "MVC Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 2nd Half Money Lines | BetQL",
        h1: "MW Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Mountain West basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 2nd Half Money Lines | BetQL",
        h1: "Northeast Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Northeast basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 2nd Half Money Lines | BetQL",
        h1: "OVC Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 2nd Half Money Lines | BetQL",
        h1: "Pac 12 Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest PAC 12 basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 2nd Half Money Lines | BetQL",
        h1: "Patriot League Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Patriot League basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 2nd Half Money Lines | BetQL",
        h1: "SEC Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest SEC basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 2nd Half Money Lines | BetQL",
        h1: "Southern Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Southern basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 2nd Half Money Lines | BetQL",
        h1: "Southland Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Southland basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 2nd Half Money Lines | BetQL",
        h1: "SWAC Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest SWAC basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 2nd Half Money Lines | BetQL",
        h1: "Summit Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Summit basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 2nd Half Money Lines | BetQL",
        h1: "Sun Belt Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Odds 2nd Half Moneyline Top 25 | BetQL",
        h1: "College Basketball Top 25 - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest Top 25 basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 2nd Half Money Lines | BetQL",
        h1: "WAC Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest WAC basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 2nd Half Money Lines | BetQL",
        h1: "WCC Basketball - 2nd Half Money Line Model Bets",
        description:
          "Check out BetQL for the latest WCC basketball 2nd half money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    spread: {
      all: {
        seoTitle: "College Basketball Odds, Lines, Spreads - All | BetQL",
        h1: "College Basketball ATS Model Bets",
        description:
          "Check out BetQL for the latest College Basketball spreads. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Odds |America East Basketball Lines & Spreads",
        h1: "America East Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest America East basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Odds |BetQL",
        h1: "AAC Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest American basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Odds |A10 Basketball Lines & Spreads | BetQL",
        h1: "A10 Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest A10 basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Odds |ACC Basketball Lines & Spreads",
        h1: "ACC Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest ACC basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Odds |ASUN Basketball Lines & Spreads | BetQL",
        h1: "ASUN Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest ASUN basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Odds |Big 12 Basketball Lines & Spreads | BetQL",
        h1: "Big 12 Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest BIG 12 basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Odds |Big East Basketball Lines & Spreads | BetQL",
        h1: "Big East Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Big East basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Odds |Big Sky Basketball Lines & Spreads | BetQL",
        h1: "Big Sky Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Big Sky basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Odds |Big South Basketball Lines & Spreads | BetQL",
        h1: "Big South Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Big South basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Odds |Big 10 Basketball Lines & Spreads | BetQL",
        h1: "Big 10 Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Big basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Odds |Big West Basketball Lines & Spreads | BetQL",
        h1: "Big West Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Big West basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Odds | BetQL",
        h1: "Colonial Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Colonial basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Odds |CUSA Basketball Lines & Spreads | BetQL",
        h1: "CUSA Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest CUSA basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Odds |Horizon League Basketball Lines & Spreads",
        h1: "Horizon League Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Horizon League basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Odds |Ivy League Basketball Lines & Spreads",
        h1: "Ivy League Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Ivy League basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Odds |MAC Basketball Lines & Spreads | BetQL",
        h1: "MAC Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest MAC basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Odds |MEAC Basketball Lines & Spreads | BetQL",
        h1: "MEAC Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest MEAC basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Odds |MAAC Basketball Lines & Spreads | BetQL",
        h1: "Metro Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Metro basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Odds |Missouri Valley Basketball Lines & Spreads",
        h1: "MVC Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Missouri Valley basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Odds |Mountain West Basketball Lines & Spreads",
        h1: "MW Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Mountain West basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Odds, Lines, Spreads |BetQL",
        h1: "Northeast Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Northeast basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Odds |Ohio Valley Basketball Lines & Spreads",
        h1: "OVC Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Ohio Valley basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Odds |Pac 12 Basketball Lines & Spreads | BetQL",
        h1: "Pac 12 Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest PAC 12 basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Odds |Patriot League Basketball Lines & Spreads",
        h1: "Patriot League Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Patriot League basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Odds |SEC Basketball Lines & Spreads | BetQL",
        h1: "SEC Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest SEC basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Odds |SoCon Basketball Lines & Spreads | BetQL",
        h1: "Southern Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Southern basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Odds, Lines, Spreads | BetQL",
        h1: "Southland Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Southland basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Odds |SWAC Basketball Lines & Spreads | BetQL",
        h1: "SWAC Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest SWAC basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Odds |Summit League Basketball Lines & Spreads",
        h1: "Summit Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Summit basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Odds |Sun Belt Basketball Lines & Spreads | BetQL",
        h1: "Sun Belt Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest Sun Belt basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Odds Spread Top 25 | BetQL",
        h1: "College Basketball Top 25 - ATS Model Bets",
        description:
          "Check out BetQL for the latest Top 25 basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Odds |WAC Basketball Lines & Spreads | BetQL",
        h1: "WAC Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest WAC basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Odds |WCC Basketball Lines & Spreads | BetQL",
        h1: "WCC Basketball - ATS Model Bets",
        description:
          "Check out BetQL for the latest WCC basketball spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
  },
  "public-betting": {
    seoTitle: "College Basketball Consensus Picks | College Basketball Public Betting | BetQL",
    h1: "College Basketball Consensus Picks",
    description:
      "Check out BetQL for the latest College Basketball consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "College Basketball 1st Half Public Betting | BetQL",
      h1: "College Basketball 1st Half Consensus Picks",
      description:
        "Check out BetQL for the latest College Basketball 1st half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB 1st Half Public Betting - All | BetQL",
        h1: "All College Basketball 1st Half Public Betting",
        description:
          "Check out BetQL for the latest College Basketball 1st half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 1st Half Public Picks | BetQL",
        h1: "America East Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest America East basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 1st Half Public Picks | BetQL",
        h1: "AAC Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest American basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 1st Half Public Picks | BetQL",
        h1: "A10 Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest A10 basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 1st Half Public Picks | BetQL",
        h1: "ACC Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest ACC basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 1st Half Public Picks | BetQL",
        h1: "ASUN Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 1st Half Public Picks | BetQL",
        h1: "Big 12 Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest BIG 12 basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 1st Half Public Picks | BetQL",
        h1: "Big East Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Big East basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 1st Half Public Picks | BetQL",
        h1: "Big Sky Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 1st Half Public Picks | BetQL",
        h1: "Big South Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Big South basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 1st Half Public Picks | BetQL",
        h1: "Big 10 Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Big basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 1st Half Public Picks | BetQL",
        h1: "Big West Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Big West basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 1st Half Public Picks | BetQL",
        h1: "Colonial Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 1st Half Public Picks | BetQL",
        h1: "CUSA Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 1st Half Public Picks | BetQL",
        h1: "Horizon Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 1st Half Public Picks | BetQL",
        h1: "Ivy League Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 1st Half Public Picks | BetQL",
        h1: "MAC Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest MAC basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 1st Half Public Picks | BetQL",
        h1: "MEAC Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 1st Half Public Picks | BetQL",
        h1: "Metro Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Metro basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 1st Half Public Picks | BetQL",
        h1: "MVC Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 1st Half Public Picks | BetQL",
        h1: "MW Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 1st Half Public Picks | BetQL",
        h1: "Northeast Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 1st Half Public Picks | BetQL",
        h1: "OVC Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 1st Half Public Picks | BetQL",
        h1: "Pac 12 Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 1st Half Public Picks | BetQL",
        h1: "Patriot League Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 1st Half Public Picks | BetQL",
        h1: "SEC Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest SEC basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 1st Half Public Picks | BetQL",
        h1: "Southern Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Southern basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 1st Half Public Picks | BetQL",
        h1: "Southland Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Southland basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 1st Half Public Picks | BetQL",
        h1: "SWAC Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 1st Half Public Picks | BetQL",
        h1: "Summit Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Summit basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 1st Half Public Picks | BetQL",
        h1: "Sun Belt Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Public Betting 1st Half Spread Top 25 | BetQL",
        h1: "Top 25 Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 1st Half Public Picks | BetQL",
        h1: "WAC Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest WAC basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 1st Half Public Picks | BetQL",
        h1: "WCC Basektball - 1st Half Public Betting",
        description:
          "Check out BetQL for the latest WCC basketball 1st half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-moneyline": {
      seoTitle: "NCAAB 1st Half Public Money Line Picks | BetQL",
      h1: "College Basketball 1st Half Money Line Public Picks",
      description:
        "Check out BetQL for the latest College Basketball 1st half money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB 1st Half Public Picks - All | BetQL",
        h1: "All College Basketball 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest College Basketball 1st half money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 1st Half Money Line Public Picks | BetQL",
        h1: "America East Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest America East basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "AAC Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest American basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "A10 Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest A10 basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "ACC Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest ACC basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "ASUN Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Big 12 Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Big East Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big East basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Big Sky Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Big South Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big South basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Big 10 Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Big West Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big West basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Colonial Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "CUSA Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Horizon Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Ivy League Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "MAC Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest MAC basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "MEAC Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Metro Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Metro basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "MVC Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "MW Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Northeast Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "OVC Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Pac 12 Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Patriot League Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "SEC Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest SEC basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Southern Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Southern basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Southland Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Southland basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "SWAC Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Summit Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Summit basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "Sun Belt Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Public Betting 1st Half Moneyline Top 25 | BetQL",
        h1: "Top 25 Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "WAC Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest WAC basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 1st Half Moneyline Public Picks | BetQL",
        h1: "WCC Basketball - 1st Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest WCC basketball 1st half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-totals-spread": {
      seoTitle: "1st Half Over Under Picks - All Conferences | BetQL",
      h1: "College Basketball 1st Half Over Under Public Picks",
      description:
        "Check out BetQL for the latest College Basketball 1st half over under consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "1st Half Over Under Picks - All Conferences | BetQL",
        h1: "All College Basketball 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest College Basketball 1st half over under consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 1st Half Over Under Picks | BetQL",
        h1: "America East Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest America East basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 1st Half Over Under Picks | BetQL",
        h1: "AAC Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest American basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 1st Half Over Under Picks | BetQL",
        h1: "A10 Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest A10 basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 1st Half Over Under Picks | BetQL",
        h1: "ACC Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest ACC basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 1st Half Over Under Picks | BetQL",
        h1: "ASUN Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 1st Half Over Under Picks | BetQL",
        h1: "Big 12 Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 1st Half Over Under Picks | BetQL",
        h1: "Big East Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big East basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 1st Half Over Under Picks | BetQL",
        h1: "Big Sky Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 1st Half Over Under Picks | BetQL",
        h1: "Big South Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big South basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big Ten Basketball 1st Half Over Under Picks | BetQL",
        h1: "Big 10 Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 1st Half Over Under Picks | BetQL",
        h1: "Big West Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big West basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Basketball 1st Half Over Under Picks | BetQL",
        h1: "Colonial Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "Conference USA Basketball 1st Half Over Under Picks | BetQL",
        h1: "CUSA Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 1st Half Over Under Picks | BetQL",
        h1: "Horizon Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 1st Half Over Under Picks | BetQL",
        h1: "Ivy League Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 1st Half Over Under Picks | BetQL",
        h1: "MAC Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest MAC basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 1st Half Over Under Picks | BetQL",
        h1: "MEAC Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "Metro Atlantic Athletic Basketball 1st Half Over Under Picks | BetQL",
        h1: "Metro Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Metro basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 1st Half Over Under Picks | BetQL",
        h1: "MVC Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 1st Half Over Under Picks | BetQL",
        h1: "MW Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Basketball 1st Half Over Under Picks | BetQL",
        h1: "Northeast Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 1st Half Over Under Picks | BetQL",
        h1: "OVC Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 1st Half Over Under Picks | BetQL",
        h1: "Pac 12 Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 1st Half Over Under Picks | BetQL",
        h1: "Patriot League Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 1st Half Over Under Picks | BetQL",
        h1: "SEC Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest SEC basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "Southern Basketball 1st Half Over Under Picks | BetQL",
        h1: "Southern Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Southern basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Basketball 1st Half Over Under Picks | BetQL",
        h1: "Southland Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Southland basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "Sotuhwestern Athletic Basketball 1st Half Over Under Picks | BetQL",
        h1: "SWAC Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 1st Half Over Under Picks | BetQL",
        h1: "Summit Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Summit basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 1st Half Over Under Picks | BetQL",
        h1: "Sun Belt Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "Top 25 1st Half Over Under Picks | BetQL",
        h1: "Top 25 Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 1st Half Over Under Picks | BetQL",
        h1: "WAC Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest WAC basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 1st Half Over Under Picks | BetQL",
        h1: "WCC Basketball - 1st Half Over Under Public Picks",
        description:
          "Check out BetQL for the latest WCC basketball 1st half public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    moneyline: {
      seoTitle: "College Basketball Money Line Public Picks | BetQL",
      h1: "College Basketball Money Line Public Picks",
      description:
        "Check out BetQL for the latest College Basketball money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "College Basketball Money Line Public Picks | BetQL",
        h1: "All College Basketball Money Line Public Picks",
        description:
          "Check out BetQL for the latest College Basketball money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basektball Money Line Public Picks | BetQL",
        h1: "America East Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest America East basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Money Line Public Picks | BetQL",
        h1: "AAC Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest American basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Moneyline Public Picks | BetQL",
        h1: "A10 Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest A10 basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Money Line Public Picks | BetQL",
        h1: "ACC Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest ACC basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Money Line Public Picks | BetQL",
        h1: "ASUN Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest ASUN basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Money Line Public Picks | BetQL",
        h1: "Big 12 Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest BIG 12 basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Money Line Public Picks | BetQL",
        h1: "Big East Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Big East basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Money Line Public Picks | BetQL",
        h1: "Big Sky Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Big Sky basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Money Line Public Picks | BetQL",
        h1: "Big South Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Big South basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Money Line Public Picks | BetQL",
        h1: "Big 10 Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Big basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Money Line Public Picks | BetQL",
        h1: "Big West Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Big West basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Money Line Public Picks | BetQL",
        h1: "Colonial Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Colonial basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Money Line Public Picks | BetQL",
        h1: "CUSA Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest CUSA basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Money Line Public Picks | BetQL",
        h1: "Horizon Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Horizon League basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Money Line Public Picks | BetQL",
        h1: "Ivy League Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Ivy League basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Money Line Public Picks | BetQL",
        h1: "MAC Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest MAC basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Money Line Public Picks | BetQL",
        h1: "MEAC Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest MEAC basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Money Line Public Picks | BetQL",
        h1: "Metro Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Metro basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Money Line Public Picks | BetQL",
        h1: "MVC Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Missouri Valley basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Money Line Public Picks | BetQL",
        h1: "MW Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Mountain West basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Money Line Public Picks | BetQL",
        h1: "Northeast Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Northeast basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Money Line Public Picks | BetQL",
        h1: "OVC Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Ohio Valley basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Money Line Public Picks | BetQL",
        h1: "Pac 12 Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest PAC 12 basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Money Line Public Picks | BetQL",
        h1: "Patriot League Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Patriot League basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Money Line Public Picks | BetQL",
        h1: "SEC Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest SEC basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Money Line Public Picks | BetQL",
        h1: "Southern Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Southern basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Money Line Public Picks | BetQL",
        h1: "Southland Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Southland basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Money Line Public Picks | BetQL",
        h1: "SWAC Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest SWAC basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Money Line Public Picks | BetQL",
        h1: "Summit Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Summit basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Money Line Public Picks | BetQL",
        h1: "Sun Belt Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Sun Belt basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Public Betting Money Line Top 25 | BetQL",
        h1: "Top 25 Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest Top 25 basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Money Line Public Picks | BetQL",
        h1: "WAC Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest WAC basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Money Line Public Picks | BetQL",
        h1: "WCC Basketball - Money Line Public Betting",
        description:
          "Check out BetQL for the latest WCC basketball public money link picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-lines": {
      seoTitle: "College Basketball 2nd Half Public Betting | BetQL",
      h1: "All College Basketball 2nd Half Public Picks",
      description:
        "Check out BetQL for the latest College Basketball 2nd half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "College Basketball 2nd Half Public Betting - All | BetQL",
        h1: "All College Basketball 2nd Half Public Picks",
        description:
          "Check out BetQL for the latest College Basketball 2nd half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 2nd Half Public Picks | BetQL",
        h1: "America East Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest America East basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 2nd Half Public Picks | BetQL",
        h1: "AAC Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest American basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 2nd Half Public Picks | BetQL",
        h1: "A10 Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest A10 basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 2nd Half Public Picks | BetQL",
        h1: "ACC Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest ACC basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 2nd Half Public Picks | BetQL",
        h1: "ASUN Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest ASUN basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 2nd Half Public Picks | BetQL",
        h1: "Big 12 Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 2nd Half Public Picks | BetQL",
        h1: "Big East Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Big East basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 2nd Half Public Picks | BetQL",
        h1: "Big Sky Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 2nd Half Public Picks | BetQL",
        h1: "Big South Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Big South basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 2nd Half Public Picks | BetQL",
        h1: "Big 10 Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Big basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 2nd Half Public Picks | BetQL",
        h1: "Big West Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Big West basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 2nd Half Public Picks | BetQL",
        h1: "Colonial Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Colonial basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 2nd Half Public Picks | BetQL",
        h1: "CUSA Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest CUSA basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 2nd Half Public Picks | BetQL",
        h1: "Horizon Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 2nd Half Public Picks | BetQL",
        h1: "Ivy League Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 2nd Half Public Picks | BetQL",
        h1: "MAC Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest MAC basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 2nd Half Public Picks | BetQL",
        h1: "MEAC Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest MEAC basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 2nd Half Public Picks | BetQL",
        h1: "Metro Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Metro basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 2nd Half Public Picks | BetQL",
        h1: "MVC Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 2nd Half Public Picks | BetQL",
        h1: "MW Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 2nd Half Public Picks | BetQL",
        h1: "Northeast Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Northeast basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 2nd Half Public Picks | BetQL",
        h1: "OVC Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 2nd Half Public Picks | BetQL",
        h1: "Pac 12 Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 2nd Half Public Picks | BetQL",
        h1: "Patriot League Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 2nd Half Public Picks | BetQL",
        h1: "SEC Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest SEC basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 2nd Half Public Picks | BetQL",
        h1: "Southern Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Southern basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 2nd Half Public Picks | BetQL",
        h1: "Southland Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Southland basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 2nd Half Public Picks | BetQL",
        h1: "SWAC Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest SWAC basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 2nd Half Public Picks | BetQL",
        h1: "Summit Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Summit basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 2nd Half Public Picks | BetQL",
        h1: "Sun Belt Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Public Betting 2nd Half Spread Top 25 | BetQL",
        h1: "Top 25 Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 2nd Half Public Picks | BetQL",
        h1: "WAC Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest WAC basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 2nd Half Public Picks | BetQL",
        h1: "WCC Basketball - 2nd Half Consensus Picks",
        description:
          "Check out BetQL for the latest WCC basketball 2nd half public betting picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-moneylines": {
      seoTitle: "College Basketball 2nd Half Moneyline Picks | BetQL",
      h1: "College Basketball 2nd Half Money Line Public Picks",
      description:
        "Check out BetQL for the latest College Basketball 2nd half money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "College Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "All College Basketball 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest College Basketball 2nd half money line consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "America East Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest America East basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "AAC Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest American basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "A10 Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest A10 basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "ACC Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest ACC basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "ASUN Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest ASUN basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Big 12 Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Big East Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big East basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Big Sky Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Big South Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big South basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Big 10 Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Big West Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Big West basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Colonial Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Colonial basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "CUSA Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest CUSA basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Horizon Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Ivy League Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "MAC Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest MAC basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "MEAC Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest MEAC basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Metro Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Metro basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "MVC Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "MW Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Northeast Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Northeast basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "OVC Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Pac 12 Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Patriot League Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "SEC Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest SEC basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Southern Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Southern basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Southland Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Southland basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "SWAC Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest SWAC basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Summit Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Summit basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "Sun Belt Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Public Betting 2nd Half Money Line Top 25 | BetQL",
        h1: "Top 25 Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "WAC Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest WAC basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 2nd Half Money Line Public Picks | BetQL",
        h1: "WCC Basketball - 2nd Half Money Line Public Picks",
        description:
          "Check out BetQL for the latest WCC basketball 2nd half public money line picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    spread: {
      all: {
        seoTitle: "NCAAB Public Betting Spread All Conferences | BetQL",
        h1: "All College Basketball ATS Consensus Picks",
        description:
          "Check out BetQL for the latest College Basketball spread consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Public Betting | BetQL",
        h1: "America East Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest America East basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Public Betting | BetQL",
        h1: "AAC Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest American basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Public Betting | BetQL",
        h1: "A10 Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest A10 basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Public Betting | BetQL",
        h1: "ACC Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest ACC basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Public Betting | BetQL",
        h1: "ASUN Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest ASUN basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Public Betting | BetQL",
        h1: "Big 12 Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Public Betting | BetQL",
        h1: "Big East Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Big East basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Public Betting | BetQL",
        h1: "Big Sky Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Public Betting | BetQL",
        h1: "Big South Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Big South basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Public Betting | BetQL",
        h1: "Big 10 Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Big basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Public Betting | BetQL",
        h1: "Big West Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Big West basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Public Betting | BetQL",
        h1: "Colonial Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Colonial basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Public Betting | BetQL",
        h1: "CUSA Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest CUSA basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Public Betting | BetQL",
        h1: "Horizon Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Public Betting | BetQL",
        h1: "Ivy League Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Public Betting | BetQL",
        h1: "MAC Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest MAC basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Public Betting | BetQL",
        h1: "MEAC Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest MEAC basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Public Betting | BetQL",
        h1: "Metro Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Metro basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Public Betting | BetQL",
        h1: "MVC Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Public Betting | BetQL",
        h1: "MW Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Public Betting | BetQL",
        h1: "Northeast Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Northeast basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Public Betting | BetQL",
        h1: "OVC Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Public Betting | BetQL",
        h1: "Pac 12 Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Public Betting | BetQL",
        h1: "Patriot League Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Public Betting | BetQL",
        h1: "SEC Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest SEC basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Public Betting | BetQL",
        h1: "Southern Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Southern basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Public Betting | BetQL",
        h1: "Southland Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Southland basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Public Betting | BetQL",
        h1: "SWAC Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest SWAC basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Public Betting | BetQL",
        h1: "Summit Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Summit basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Public Betting | BetQL",
        h1: "Sun Belt Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Public Betting Spread Top 25 | BetQL",
        h1: "Top 25 Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Public Betting | BetQL",
        h1: "WAC Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest WAC basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Public Betting | BetQL",
        h1: "WCC Basketball - ATS Consensus Picks",
        description:
          "Check out BetQL for the latest WCC basketball public ATS picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "totals-spread": {
      seoTitle: "College Basketball Public Over Under Picks | BetQL",
      h1: "College Basketball Over Under Public Picks",
      description:
        "Check out BetQL for the latest College Basketball over under consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Public Betting Total All Conferences | BetQL",
        h1: "All College Basketball Over Under Public Picks",
        description:
          "Check out BetQL for the latest College Basketball over under consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Public Over Under Picks | BetQL",
        h1: "America East Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest America East basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Public Over Under Picks | BetQL",
        h1: "AAC Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest American basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Public Over Under Picks | BetQL",
        h1: "A10 Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest A10 basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Public Over Under Picks | BetQL",
        h1: "ACC Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest ACC basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Public Over Under Picks | BetQL",
        h1: "ASUN Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest ASUN basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Public Over Under Picks | BetQL",
        h1: "Big 12 Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Public Over Under Picks | BetQL",
        h1: "Big East Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big East basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Public Over Under Picks | BetQL",
        h1: "Big Sky Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Public Over Under Picks | BetQL",
        h1: "Big South Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big South basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Public Over Under Picks | BetQL",
        h1: "Big 10 Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Public Over Under Picks | BetQL",
        h1: "Big West Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Big West basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Public Over Under Picks | BetQL",
        h1: "Colonial Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Colonial basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Public Over Under Picks | BetQL",
        h1: "CUSA Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest CUSA basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Public Over Under Picks | BetQL",
        h1: "Horizon Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Public Over Under Picks | BetQL",
        h1: "Ivy League Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Public Over Under Picks | BetQL",
        h1: "MAC Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest MAC basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Public Over Under Picks | BetQL",
        h1: "MEAC Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest MEAC basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Public Over Under Picks | BetQL",
        h1: "Metro Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Metro basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Public Over Under Picks | BetQL",
        h1: "MVC Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Public Over Under Picks | BetQL",
        h1: "MW Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Public Over Under Picks | BetQL",
        h1: "Northeast Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Northeast basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Public Over Under Picks | BetQL",
        h1: "OVC Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Public Over Under Picks | BetQL",
        h1: "Pac 12 Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Public Over Under Picks | BetQL",
        h1: "Patriot League Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Public Over Under Picks | BetQL",
        h1: "SEC Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest SEC basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Public Over Under Picks | BetQL",
        h1: "Southern Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Southern basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Public Over Under Picks | BetQL",
        h1: "Southland Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Southland basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Public Over Under Picks | BetQL",
        h1: "SWAC Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest SWAC basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Public Over Under Picks | BetQL",
        h1: "Summit Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Summit basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Public Over Under Picks | BetQL",
        h1: "Sun Belt Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Public Betting Total Top 25 | BetQL",
        h1: "Top 25 Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Public Over Under Picks | BetQL",
        h1: "WAC Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest WAC basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Public Over Under Picks | BetQL",
        h1: "WCC Basketball - Over Under Public Picks",
        description:
          "Check out BetQL for the latest WCC basketball public over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
  },
  "sharp-picks": {
    seoTitle: "College Basketball Picks | College Basketball Expert Picks | BetQL",
    h1: "College Basketball Picks Against the Spread",
    description:
      "Check out BetQL for the latest College Basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "College Basketball 1st Half Expert Picks | NCAAB 1st Half Sharp Picks | BetQL",
      h1: "College Basketball 1st Half Odds",
      description:
        "Check out BetQL for the latest College Basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Sharp Picks 1st Half Spread All Conferences | BetQL",
        h1: "All College Basketball 1st Half Odds",
        description:
          "Check out BetQL for the latest College Basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Expert 1st Half Picks | BetQL",
        h1: "America East Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest America East basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Expert 1st Half Picks | BetQL",
        h1: "AAC Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest American basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Expert 1st Half Picks | BetQL",
        h1: "A10 Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest A10 basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Expert 1st Half Picks | BetQL",
        h1: "ACC Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest ACC basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Expert 1st Half Picks | BetQL",
        h1: "ASUN Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Expert 1st Half Picks | BetQL",
        h1: "Big 12 Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Expert 1st Half Picks | BetQL",
        h1: "Big East Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Big East basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Expert 1st Half Picks | BetQL",
        h1: "Big Sky Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Expert 1st Half Picks | BetQL",
        h1: "Big South Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Big South basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Expert 1st Half Picks | BetQL",
        h1: "Big Ten Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Big basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Expert 1st Half Picks | BetQL",
        h1: "Big West Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Big West basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Expert 1st Half Picks | BetQL",
        h1: "Colonial Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Expert 1st Half Picks | BetQL",
        h1: "CUSA Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Expert 1st Half Picks | BetQL",
        h1: "Horizon League Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Expert 1st Half Picks | BetQL",
        h1: "Ivy League Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Expert 1st Half Picks | BetQL",
        h1: "MAC Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest MAC basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Expert 1st Half Picks | BetQL",
        h1: "MEAC Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Expert 1st Half Picks | BetQL",
        h1: "Metro Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Metro basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Expert 1st Half Picks | BetQL",
        h1: "MVC Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Expert 1st Half Picks | BetQL",
        h1: "MW Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Expert 1st Half Picks | BetQL",
        h1: "North East Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Expert 1st Half Picks | BetQL",
        h1: "OVC Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Expert 1st Half Picks | BetQL",
        h1: "Pac 12 Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Expert 1st Half Picks | BetQL",
        h1: "Patriot Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Expert 1st Half Picks | BetQL",
        h1: "SEC Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest SEC basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Expert 1st Half Picks | BetQL",
        h1: "Southern Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Southern basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Expert 1st Half Picks | BetQL",
        h1: "Southland Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Southland basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Expert 1st Half Picks | BetQL",
        h1: "SWAC Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Expert 1st Half Picks | BetQL",
        h1: "Summit Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Summit basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Expert 1st Half Picks | BetQL",
        h1: "Sun Belt Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Sharp Picks 1st Half Spread Top 25 | BetQL",
        h1: "College Basketball Top 25 - 1st Half Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Expert 1st Half Picks | BetQL",
        h1: "WAC Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest WAC basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Expert 1st Half Picks | BetQL",
        h1: "WCC Basketball - 1st Half Picks",
        description:
          "Check out BetQL for the latest WCC basketball 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-moneyline": {
      seoTitle: "College Basketball 1st Half Expert Moneyline Picks | BetQL",
      h1: "College Basketball 1st Half Money Line Picks",
      description:
        "Check out BetQL for the latest College Basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Sharp Picks 1st Half Moneyline All Conferences | BetQL",
        h1: "All College Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest College Basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "America East Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest America East basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "AAC Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest American basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "A10 Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest A10 basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "ACC Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest ACC basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "ASUN Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Big 12 Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Big East Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Big East basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Big Sky Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Big South Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Big South basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Big Ten Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Big basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Big West Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Big West basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Colonial Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "CUSA Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Horizon Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Ivy League Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "MAC Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest MAC basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "MEAC Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Metro Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Metro basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "MVC Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "MW Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "North East Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "OVC Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Pac 12 Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Patriot Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "SEC Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest SEC basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Southern Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Southern basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Southland Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Southland basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "SWAC Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Summit Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Summit basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "Sun Belt Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Sharp Picks 1st Half Moneyline Top 25 | BetQL",
        h1: "Top 25 Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "WAC Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest WAC basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Expert 1st Half Moneyline Picks | BetQL",
        h1: "WCC Basketball - 1st Half Money Line Picks",
        description:
          "Check out BetQL for the latest WCC basketball 1st half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-totals-spread": {
      seoTitle: "NCAAB Sharp Picks 1st Half Total All Conferences | BetQL",
      h1: "College Basketball 1st Half Over Under Picks",
      description:
        "Check out BetQL for the latest College Basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total All Conferences | BetQL",
        h1: "All College Basketball 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest College Basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total America East | BetQL",
        h1: "America East Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest America East basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total American | BetQL",
        h1: "AAC Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest American basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Atlantic 10 | BetQL",
        h1: "A10 Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest A10 basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total ACC | BetQL",
        h1: "ACC Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest ACC basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total ASUN | BetQL",
        h1: "ASUN Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Big 12 | BetQL",
        h1: "Big 12 Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Big East | BetQL",
        h1: "Big East Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Big East basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Big Sky | BetQL",
        h1: "Big Sky Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Big South | BetQL",
        h1: "Big South Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Big South basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Big Ten | BetQL",
        h1: "Big Ten Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Big basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Big West | BetQL",
        h1: "Big West Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Big West basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Colonial | BetQL",
        h1: "Colonial Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Conference USA | BetQL",
        h1: "CUSA Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Horizon League | BetQL",
        h1: "Horizon Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Ivy League | BetQL",
        h1: "Ivy League Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total MAC | BetQL",
        h1: "MAC Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest MAC basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total MEAC | BetQL",
        h1: "MEAC Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Metro Atlantic Athletic | BetQL",
        h1: "Metro Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Metro basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Missouri Valley | BetQL",
        h1: "MVC Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Mountain West | BetQL",
        h1: "MW Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Northeast | BetQL",
        h1: "North East Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Ohio Valley | BetQL",
        h1: "OVC Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Pac-12 | BetQL",
        h1: "Pac 12 Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Patriot League | BetQL",
        h1: "Patriot Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total SEC | BetQL",
        h1: "SEC Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest SEC basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Southern | BetQL",
        h1: "Southern Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Southern basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Southland | BetQL",
        h1: "Southland Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Southland basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Southwestern Athletic | BetQL",
        h1: "SWAC Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Summit | BetQL",
        h1: "Summit Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Summit basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Sun Belt | BetQL",
        h1: "Sun Belt Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total Top 25 | BetQL",
        h1: "Top 25 Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "NCAAB Sharp Picks 1st Half Total WAC | BetQL",
        h1: "WAC Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest WAC basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "NCAAB Sharp Picks 1st Half Total West Coast | BetQL",
        h1: "WCC Basketball - 1st Half Over Under Picks",
        description:
          "Check out BetQL for the latest WCC basketball 1st half over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    moneyline: {
      seoTitle: "College Basketball Expert Moneyline Picks | NCAAB Sharp ML Picks | BetQL",
      h1: "College Basketball Money Line Picks",
      description:
        "Check out BetQL for the latest College Basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Sharp Picks Moneyline All Conferences | BetQL",
        h1: "All College Basketball Money Line Picks",
        description:
          "Check out BetQL for the latest College Basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Moneyline Expert Picks | BetQL",
        h1: "America East Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest America East basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Moneyline Expert Picks | BetQL",
        h1: "AAC Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest American basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Moneyline Expert Picks | BetQL",
        h1: "A10 Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest A10 basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Moneyline Expert Picks | BetQL",
        h1: "ACC Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest ACC basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Moneyline Expert Picks | BetQL",
        h1: "ASUN Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest ASUN basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Moneyline Expert Picks | BetQL",
        h1: "Big 12 Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Moneyline Expert Picks | BetQL",
        h1: "Big East Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Big East basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Moneyline Expert Picks | BetQL",
        h1: "Big Sky Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Moneyline Expert Picks | BetQL",
        h1: "Big South Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Big South basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Moneyline Expert Picks | BetQL",
        h1: "Big Ten Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Big basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Moneyline Expert Picks | BetQL",
        h1: "Big West Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Big West basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Moneyline Expert Picks | BetQL",
        h1: "Colonial Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Colonial basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Moneyline Expert Picks | BetQL",
        h1: "CUSA Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest CUSA basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Moneyline Expert Picks | BetQL",
        h1: "Horizon Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Moneyline Expert Picks | BetQL",
        h1: "Ivy League Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Moneyline Expert Picks | BetQL",
        h1: "MAC Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest MAC basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Moneyline Expert Picks | BetQL",
        h1: "MEAC Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest MEAC basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Moneyline Expert Picks | BetQL",
        h1: "Metro Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Metro basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Moneyline Expert Picks | BetQL",
        h1: "MVC Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Moneyline Expert Picks | BetQL",
        h1: "MW Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Moneyline Expert Picks | BetQL",
        h1: "North East Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Northeast basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Moneyline Expert Picks | BetQL",
        h1: "OVC Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Moneyline Expert Picks | BetQL",
        h1: "Pac 12 Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Moneyline Expert Picks | BetQL",
        h1: "Patriot Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Moneyline Expert Picks | BetQL",
        h1: "SEC Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest SEC basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Moneyline Expert Picks | BetQL",
        h1: "Southern Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Southern basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Moneyline Expert Picks | BetQL",
        h1: "Southland Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Southland basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Moneyline Expert Picks | BetQL",
        h1: "SWAC Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest SWAC basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Moneyline Expert Picks | BetQL",
        h1: "Summit Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Summit basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Moneyline Expert Picks | BetQL",
        h1: "Sun Belt Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Sharp Picks Moneyline Top 25 | BetQL",
        h1: "Top 25 Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Moneyline Expert Picks | BetQL",
        h1: "WAC Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest WAC basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Moneyline Expert Picks | BetQL",
        h1: "WCC Basketball - Money Line Picks",
        description:
          "Check out BetQL for the latest WCC basketball money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-lines": {
      seoTitle: "College Basketball 2nd Half Expert Picks | NCAAB 2nd Half Sharp Picks | BetQL",
      h1: "College Basketball 2nd Half Picks",
      description:
        "Check out BetQL for the latest College Basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Sharp Picks 2nd Half Spread All Conferences | BetQL",
        h1: "All College Basketball 2nd Half Picks",
        description:
          "Check out BetQL for the latest College Basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Expert 2nd Half Picks | BetQL",
        h1: "America East Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest America East basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Expert 2nd Half Picks | BetQL",
        h1: "AAC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest American basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Expert 2nd Half Picks | BetQL",
        h1: "A10 Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest A10 basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Expert 2nd Half Picks | BetQL",
        h1: "ACC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest ACC basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Expert 2nd Half Picks | BetQL",
        h1: "ASUN Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest ASUN basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Expert 2nd Half Picks | BetQL",
        h1: "Big 12 Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest BIG 12 basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Expert 2nd Half Picks | BetQL",
        h1: "Big East Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Big East basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Expert 2nd Half Picks | BetQL",
        h1: "Big Sky Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Big Sky basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Expert 2nd Half Picks | BetQL",
        h1: "Big South Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Big South basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Expert 2nd Half Picks | BetQL",
        h1: "Big Ten Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Big basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Expert 2nd Half Picks | BetQL",
        h1: "Big West Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Big West basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Expert 2nd Half Picks | BetQL",
        h1: "Colonial Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Colonial basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Expert 2nd Half Picks | BetQL",
        h1: "CUSA Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest CUSA basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Expert 2nd Half Picks | BetQL",
        h1: "Horizon Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Horizon League basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Expert 2nd Half Picks | BetQL",
        h1: "Ivy League Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Ivy League basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Expert 2nd Half Picks | BetQL",
        h1: "MAC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest MAC basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Expert 2nd Half Picks | BetQL",
        h1: "MEAC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest MEAC basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Expert 2nd Half Picks | BetQL",
        h1: "Metro Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Metro basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Expert 2nd Half Picks | BetQL",
        h1: "MVC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Expert 2nd Half Picks | BetQL",
        h1: "MW Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Mountain West basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Expert 2nd Half Picks | BetQL",
        h1: "North East Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Northeast basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Expert 2nd Half Picks | BetQL",
        h1: "OVC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Expert 2nd Half Picks | BetQL",
        h1: "Pac 12 Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest PAC 12 basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Expert 2nd Half Picks | BetQL",
        h1: "Patriot Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Patriot League basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Expert 2nd Half Picks | BetQL",
        h1: "SEC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest SEC basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Expert 2nd Half Picks | BetQL",
        h1: "Southern Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Southern basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Expert 2nd Half Picks | BetQL",
        h1: "Southland Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Southland basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Expert 2nd Half Picks | BetQL",
        h1: "SWAC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest SWAC basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Expert 2nd Half Picks | BetQL",
        h1: "Summit Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Summit basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Expert 2nd Half Picks | BetQL",
        h1: "Sun Belt Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Sun Belt basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Sharp Picks 2nd Half Spread Top 25 | BetQL",
        h1: "Top 25 Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Top 25 basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Expert 2nd Half Picks | BetQL",
        h1: "WAC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest WAC basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Expert 2nd Half Picks | BetQL",
        h1: "West Coast Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest WCC basketball 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-moneylines": {
      seoTitle: "College Basketball 2nd Half Expert Moneyline Picks | BetQL",
      h1: "Basketball - 2nd Half Picks ATS",
      description:
        "Check out BetQL for the latest College Basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Sharp Picks 2nd Half Moneyline All Conferences | BetQL",
        h1: "Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest College Basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "America East Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest America East basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "AAC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest American basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "A10 Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest A10 basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "ACC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest ACC basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "ASUN Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest ASUN basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Big 12 Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest BIG 12 basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Big East Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Big East basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Big Sky Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Big Sky basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Big South Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Big South basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Big Ten Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Big basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Big West Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Big West basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Colonial Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Colonial basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "CUSA Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest CUSA basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Horizon Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Horizon League basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Ivy League Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Ivy League basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "MAC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest MAC basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "MEAC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest MEAC basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Metro Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Metro basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "MVC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "MW Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Mountain West basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "North East Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Northeast basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "OVC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Pac 12 Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest PAC 12 basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Patriot Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Patriot League basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "SEC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest SEC basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Southern Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Southern basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Southland Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Southland basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "SWAC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest SWAC basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Summit Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Summit basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "Sun Belt Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Sun Belt basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Sharp Picks 2nd Half Moneyline Top 25 | BetQL",
        h1: "Top 25 Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest Top 25 basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "WAC Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest WAC basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Expert 2nd Half Moneyline Picks | BetQL",
        h1: "West Coast Basketball - 2nd Half Picks ATS",
        description:
          "Check out BetQL for the latest WCC basketball 2nd half money line expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    spread: {
      all: {
        seoTitle: "NCAAB Sharp Picks Spread All Conferences | BetQL",
        h1: "All College Basketball Picks Against the Spread",
        description:
          "Check out BetQL for the latest College Basketball spread expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Expert Picks | America East Basketball Sharp Picks | BetQL",
        h1: "America East Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest America East basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Expert Picks | American Conference Basketball Sharp Picks | BetQL",
        h1: "AAC Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest American basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Expert Picks | A10 Basketball Sharp Picks | BetQL",
        h1: "A10 Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest A10 basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Expert Picks | ACC Basketball Sharp Picks | BetQL",
        h1: "ACC Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest ACC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Expert Picks | ASUN Basketball Sharp Picks | BetQL",
        h1: "ASUN Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest ASUN basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Expert Picks | Big 12 Basketball Sharp Picks | BetQL",
        h1: "Big 12 Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest BIG 12 basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Expert Picks | Big East Basketball Sharp Picks | BetQL",
        h1: "Big East Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Big East basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Expert Picks | Big Sky Basketball Sharp Picks | BetQL",
        h1: "Big Sky Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Big Sky basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Expert Picks | Big South Basketball Sharp Picks | BetQL",
        h1: "Big South Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Big South basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Expert Picks | Big 10 Basketball Sharp Picks | BetQL",
        h1: "Big Ten Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Big basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Expert Picks | Big West Basketball Sharp Picks | BetQL",
        h1: "Big West Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Big West basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Expert Picks | Colonial Conference Basketball Sharp Picks | BetQL",
        h1: "Colonial Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Colonial basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Expert Picks | CUSA Basketball Sharp Picks | BetQL",
        h1: "CUSA Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest CUSA basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Expert Picks | Horizon League Basketball Sharp Picks | BetQL",
        h1: "Horizon Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Horizon League basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Expert Picks | Ivy League Basketball Sharp Picks | BetQL",
        h1: "Ivy League Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Ivy League basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Expert Picks | MAC Basketball Sharp Picks | BetQL",
        h1: "MAC Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest MAC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Expert Picks | MEAC Basketball Sharp Picks | BetQL",
        h1: "MEAC Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest MEAC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Expert Picks | MAAC Basketball Sharp Picks | BetQL",
        h1: "Metro Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Metro basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Expert Picks | Missouri Valley Basketball Sharp Picks | BetQL",
        h1: "MVC Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Missouri Valley basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Expert Picks | Mountain West Basketball Sharp Picks | BetQL",
        h1: "MW Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Mountain West basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Expert Picks | Northeast Conference Basketball Sharp Picks | BetQL",
        h1: "North East Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Northeast basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Expert Picks | Ohio Valley Basketball Sharp Picks | BetQL",
        h1: "OVC Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Ohio Valley basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Expert Picks | Pac 12 Basketball Sharp Picks | BetQL",
        h1: "Pac 12 Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest PAC 12 basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Expert Picks | Patriot League Basketball Sharp Picks | BetQL",
        h1: "Patriot Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Patriot League basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Expert Picks | SEC Basketball Sharp Picks | BetQL",
        h1: "SEC Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest SEC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Expert Picks | SoCon Basketball Sharp Picks | BetQL",
        h1: "Southern Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Southern basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Expert Picks | Southland Conference Basketball Sharp Picks | BetQL",
        h1: "Southland Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Southland basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Expert Picks | SWAC Basketball Sharp Picks | BetQL",
        h1: "SWAC Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest SWAC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Expert Picks | Summit League Basketball Sharp Picks | BetQL",
        h1: "Summit Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Summit basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Expert Picks | Sun Belt Basketball Sharp Picks | BetQL",
        h1: "Sun Belt Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Sun Belt basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Sharp Picks Spread Top 25 | BetQL",
        h1: "Top 25 Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest Top 25 basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Expert Picks | WAC Basketball Sharp Picks | BetQL",
        h1: "WAC Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest WAC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Expert Picks | WCC Basketball Sharp Picks | BetQL",
        h1: "West Coast Basketball - Picks Against the Spread",
        description:
          "Check out BetQL for the latest WCC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "totals-spread": {
      seoTitle: "College Basketball Expert Over Under Picks | BetQL",
      h1: "College Basketball Over Under Expert Picks",
      description:
        "Check out BetQL for the latest College Basketball over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "College Basketball Expert Over Under Picks - All | BetQL",
        h1: "All College Basketball Over Under Expert Picks",
        description:
          "Check out BetQL for the latest College Basketball over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Over Under Expert Picks | BetQL",
        h1: "America East Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest America East basketball expert over under picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "AAC Basketball Over Under Expert Picks | BetQL",
        h1: "AAC Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest American basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Over Under Expert Picks | BetQL",
        h1: "A10 Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest A10 basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Over Under Expert Picks | BetQL",
        h1: "ACC Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest ACC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Over Under Expert Picks | BetQL",
        h1: "ASUN Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest ASUN basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Over Under Expert Picks | BetQL",
        h1: "Big 12 Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest BIG 12 basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Over Under Expert Picks | BetQL",
        h1: "Big East Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Big East basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Over Under Expert Picks | BetQL",
        h1: "Big Sky Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Big Sky basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Over Under Expert Picks | BetQL",
        h1: "Big South Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Big South basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Over Under Expert Picks | BetQL",
        h1: "Big Ten Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Big basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Over Under Expert Picks | BetQL",
        h1: "Big West Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Big West basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Basketball Over Under Expert Picks | BetQL",
        h1: "Colonial Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Colonial basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Over Under Expert Picks | BetQL",
        h1: "CUSA Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest CUSA basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Over Under Expert Picks | BetQL",
        h1: "Horizon Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Horizon League basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Over Under Expert Picks | BetQL",
        h1: "Ivy League Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Ivy League basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Over Under Expert Picks | BetQL",
        h1: "MAC Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest MAC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "Meac Basketball Over Under Expert Picks | BetQL",
        h1: "MEAC Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest MEAC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "Metro Basketball Over Under Expert Picks | BetQL",
        h1: "Metro Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Metro basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "MV Basketball Over Under Expert Picks | BetQL",
        h1: "MVC Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Missouri Valley basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "MW Basketball Over Under Expert Picks | BetQL",
        h1: "MW Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Mountain West basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Basketball Over Under Expert Picks | BetQL",
        h1: "North East Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Northeast basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Over Under Expert Picks | BetQL",
        h1: "OVC Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Ohio Valley basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Over Under Expert Picks | BetQL",
        h1: "Pac 12 Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest PAC 12 basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Over Under Expert Picks | BetQL",
        h1: "Patriot Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Patriot League basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Over Under Expert Picks | BetQL",
        h1: "SEC Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest SEC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "Southern Basketball Over Under Expert Picks | BetQL",
        h1: "Southern Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Southern basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Basketball Over Under Expert Picks | BetQL",
        h1: "Southland Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Southland basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Over Under Expert Picks | BetQL",
        h1: "SWAC Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest SWAC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit Basketball Over Under Expert Picks | BetQL",
        h1: "Summit Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Summit basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Over Under Expert Picks | BetQL",
        h1: "Sun Belt Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Sun Belt basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Top 25 Basketball Over Under Expert Picks | BetQL",
        h1: "Top 25 Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest Top 25 basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Over Under Expert Picks | BetQL",
        h1: "WAC Basketball - Expert Over Under Picks",
        description:
          "Check out BetQL for the latest WAC basketball expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
  },
  "line-movement": {
    seoTitle: "College Basketball Line Movement | NCAAB Line Movement Tracker | BetQL",
    h1: "College Basketball Line Movement",
    description:
      "Check out BetQL for the latest College Basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "College Basketball 1st Half Line Movement | BetQL",
      h1: "College Basketball 1st Half Line Movement",
      description:
        "Check out BetQL for the latest College Basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "All NCAAB 1st Half Line Movement | BetQL",
        h1: "All College Basketball 1st Half Line Movement",
        description:
          "Check out BetQL for the latest College Basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 1st Half Line Movement | BetQL",
        h1: "America East Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest America East basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 1st Half Line Movement | BetQL",
        h1: "AAC Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest AAC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 1st Half Line Movement | BetQL",
        h1: "A10 Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest A10 basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 1st Half Line Movement | BetQL",
        h1: "ACC Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest ACC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 1st Half Line Movement | BetQL",
        h1: "ASUN Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 1st Half Line Movement | BetQL",
        h1: "Big 12 Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Big 12 basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 1st Half Line Movement | BetQL",
        h1: "Big East Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Big East basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 1st Half Line Movement | BetQL",
        h1: "Big Sky Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 1st Half Line Movement | BetQL",
        h1: "Big South Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Big South basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 1st Half Line Movement | BetQL",
        h1: "Big 10 Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Big 10 basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 1st Half Line Movement | BetQL",
        h1: "Big West Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Big West basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 1st Half Line Movement | BetQL",
        h1: "Colonial Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 1st Half Line Movement | BetQL",
        h1: "CUSA Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 1st Half Line Movement | BetQL",
        h1: "Horizon League Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 1st Half Line Movement | BetQL",
        h1: "Ivy League Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 1st Half Line Movement | BetQL",
        h1: "MAC Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest MAC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 1st Half Line Movement | BetQL",
        h1: "MEAC Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 1st Half Line Movement | BetQL",
        h1: "Metro Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Metro basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 1st Half Line Movement | BetQL",
        h1: "MVC Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 1st Half Line Movement | BetQL",
        h1: "MW Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 1st Half Line Movement | BetQL",
        h1: "Northeast Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 1st Half Line Movement | BetQL",
        h1: "OVC Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 1st Half Line Movement | BetQL",
        h1: "Pac 12 Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 1st Half Line Movement | BetQL",
        h1: "Patriot League Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 1st Half Line Movement | BetQL",
        h1: "SEC Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest SEC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 1st Half Line Movement | BetQL",
        h1: "Southern Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Southern basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 1st Half Line Movement | BetQL",
        h1: "Southland Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Southland basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 1st Half Line Movement | BetQL",
        h1: "SWAC Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 1st Half Line Movement | BetQL",
        h1: "Summit Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Summit basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 1st Half Line Movement | BetQL",
        h1: "Sun Belt Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Line Movement 1st Half Spread Top 25 | BetQL",
        h1: "Top 25 Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 1st Half Line Movement | BetQL",
        h1: "WAC Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest WAC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 1st Half Line Movement | BetQL",
        h1: "WCC Basketball - 1st Half Line Movement",
        description:
          "Check out BetQL for the latest WCC basketball 1st half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-moneyline": {
      seoTitle: "College Basketball 1st Half Money Line Movement | BetQL",
      h1: "College Basketball 1st Half Money Line Movement",
      description:
        "Check out BetQL for College Basketball 1st Half Money Line Movement. Get the most updated odds, lines, spreads, and picks from BetQL. Start winning more bets",
      all: {
        seoTitle: "NCAAB Line Movement 1st Half Moneyline All Conferences | BetQL",
        h1: "All College Basketball 1st Half Money Line Movement",
        description:
          "Check out BetQL for NCAAB Line Movement 1st Half Moneyline All Conferences. Get the most updated odds, lines, spreads, and picks from BetQL. Start winning more bets",
      },
      "america-east": {
        seoTitle: "America East Basketball 1st Moneyline Movement | BetQL",
        h1: "America East Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest America East basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 1st Moneyline Movement | BetQL",
        h1: "AAC Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest AAC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 1st Moneyline Movement | BetQL",
        h1: "A10 Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest A10 basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 1st Moneyline Movement | BetQL",
        h1: "ACC Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest ACC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 1st Moneyline Movement | BetQL",
        h1: "ASUN Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 1st Moneyline Movement | BetQL",
        h1: "Big 12 Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big 12 basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 1st Moneyline Movement | BetQL",
        h1: "Big East Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big East basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 1st Moneyline Movement | BetQL",
        h1: "Big Sky Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 1st Moneyline Movement | BetQL",
        h1: "Big South Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big South basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 1st Moneyline Movement | BetQL",
        h1: "Big 10 Basketball 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big 10 basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 1st Moneyline Movement | BetQL",
        h1: "Big West Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big West basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 1st Moneyline Movement | BetQL",
        h1: "Colonial Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 1st Moneyline Movement | BetQL",
        h1: "CUSA Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 1st Moneyline Movement | BetQL",
        h1: "Horizon League Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 1st Moneyline Movement | BetQL",
        h1: "Ivy League Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 1st Moneyline Movement | BetQL",
        h1: "MAC Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest MAC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 1st Moneyline Movement | BetQL",
        h1: "MEAC Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 1st Moneyline Movement | BetQL",
        h1: "Metro Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Metro basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 1st Moneyline Movement | BetQL",
        h1: "MVC Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 1st Moneyline Movement | BetQL",
        h1: "MW Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 1st Moneyline Movement | BetQL",
        h1: "Northeast Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 1st Moneyline Movement | BetQL",
        h1: "OVC Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 1st Moneyline Movement | BetQL",
        h1: "Pac 12 Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 1st Moneyline Movement | BetQL",
        h1: "Patriot League Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 1st Moneyline Movement | BetQL",
        h1: "SEC Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest SEC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 1st Moneyline Movement | BetQL",
        h1: "Southern Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Southern basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 1st Moneyline Movement | BetQL",
        h1: "Southland Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Southland basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 1st Moneyline Movement | BetQL",
        h1: "SWAC Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 1st Moneyline Movement | BetQL",
        h1: "Summit Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Summit basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 1st Moneyline Movement | BetQL",
        h1: "Sun Belt Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Line Movement 1st Half Moneyline Top 25 | BetQL",
        h1: "Top 25 Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 1st Moneyline Movement | BetQL",
        h1: "WAC Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest WAC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 1st Moneyline Movement | BetQL",
        h1: "WCC Basketball - 1st Half Money Line Movement",
        description:
          "Check out BetQL for the latest WCC basketball 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "first-half-totals-spread": {
      seoTitle: "NCAAB Line Movement 1st Half Total All Conferences | BetQL",
      h1: "College Basketball 1st Half Over Under Line Movement",
      description:
        "Check out BetQL for NCAAB Line Movement 1st Half Total All Conferences. Get the most updated odds, lines, spreads, and picks from BetQL. Start winning more bets",
      all: {
        seoTitle: "NCAAB Line Movement 1st Half Total All Conferences | BetQL",
        h1: "All College Basketball 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for NCAAB Line Movement 1st Half Total All Conferences. Get the most updated odds, lines, spreads, and picks from BetQL. Start winning more bets",
      },
      "america-east": {
        seoTitle: "NCAAB Line Movement 1st Half Total America East | BetQL",
        h1: "America East Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest America East basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "NCAAB Line Movement 1st Half Total American | BetQL",
        h1: "AAC Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest AAC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "NCAAB Line Movement 1st Half Total Atlantic 10 | BetQL",
        h1: "A10 Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest A10 basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "NCAAB Line Movement 1st Half Total ACC | BetQL",
        h1: "ACC Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest ACC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "NCAAB Line Movement 1st Half Total ASUN | BetQL",
        h1: "ASUN Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest ASUN basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "NCAAB Line Movement 1st Half Total Big 12 | BetQL",
        h1: "Big 12 Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big 12 basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "NCAAB Line Movement 1st Half Total Big East | BetQL",
        h1: "Big East Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big East basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "NCAAB Line Movement 1st Half Total Big Sky | BetQL",
        h1: "Big Sky Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big Sky basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "NCAAB Line Movement 1st Half Total Big South | BetQL",
        h1: "Big South Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big South basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "NCAAB Line Movement 1st Half Total Big Ten | BetQL",
        h1: "Big 10 Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big 10 basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "NCAAB Line Movement 1st Half Total Big West | BetQL",
        h1: "Big West Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big West basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "NCAAB Line Movement 1st Half Total Colonial | BetQL",
        h1: "Colonial Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Colonial basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "NCAAB Line Movement 1st Half Total Conference USA | BetQL",
        h1: "CUSA Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest CUSA basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "NCAAB Line Movement 1st Half Total Horizon League | BetQL",
        h1: "Horizon League Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Horizon League basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "NCAAB Line Movement 1st Half Total Ivy League | BetQL",
        h1: "Ivy League Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Ivy League basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "NCAAB Line Movement 1st Half Total MAC | BetQL",
        h1: "MAC Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest MAC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "NCAAB Line Movement 1st Half Total MEAC | BetQL",
        h1: "MEAC Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest MEAC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "NCAAB Line Movement 1st Half Total Metro Atlantic Athletic | BetQL",
        h1: "Metro Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Metro basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "NCAAB Line Movement 1st Half Total Missouri Valley | BetQL",
        h1: "MVC Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "NCAAB Line Movement 1st Half Total Mountain West | BetQL",
        h1: "MW Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Mountain West basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "NCAAB Line Movement 1st Half Total Northeast | BetQL",
        h1: "Northeast Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Northeast basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "NCAAB Line Movement 1st Half Total Ohio Valley | BetQL",
        h1: "OVC Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "NCAAB Line Movement 1st Half Total Pac-12 | BetQL",
        h1: "Pac 12 Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest PAC 12 basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "NCAAB Line Movement 1st Half Total Patriot League | BetQL",
        h1: "Patriot League Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Patriot League basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "NCAAB Line Movement 1st Half Total SEC | BetQL",
        h1: "SEC Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest SEC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "NCAAB Line Movement 1st Half Total Southern | BetQL",
        h1: "Southern Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Southern basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "NCAAB Line Movement 1st Half Total Southland | BetQL",
        h1: "Southland Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Southland basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "NCAAB Line Movement 1st Half Total Southwestern Athletic | BetQL",
        h1: "SWAC Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest SWAC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "NCAAB Line Movement 1st Half Total Summit | BetQL",
        h1: "Summit Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Summit basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "NCAAB Line Movement 1st Half Total Sun Belt | BetQL",
        h1: "Sun Belt Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Line Movement 1st Half Total Top 25 | BetQL",
        h1: "Top 25 Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest Top 25 basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "NCAAB Line Movement 1st Half Total WAC | BetQL",
        h1: "WAC Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest WAC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "NCAAB Line Movement 1st Half Total West Coast | BetQL",
        h1: "WCC Basketball - 1st Half Over Under Line Movement",
        description:
          "Check out BetQL for the latest WCC basketball 1st half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    moneyline: {
      seoTitle: "College Basketball Moneyline Movment | BetQL",
      h1: "College Basketball Money Line Movement",
      description:
        "Check out BetQL for College Basketball Moneyline Movment. Get the most updated odds, lines, spreads, and picks from BetQL. Start winning more bets",
      all: {
        seoTitle: "NCAAB Line Movement Moneyline All Conferences | BetQL",
        h1: "All College Basketball Money Line Movement",
        description:
          "Check out BetQL for NCAAB Line Movement Moneyline All Conferences. Get the most updated odds, lines, spreads, and picks from BetQL. Start winning more bets",
      },
      "america-east": {
        seoTitle: "America East Basketball Moneyline Movement | BetQL",
        h1: "America East Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest America East basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Moneyline Movement | BetQL",
        h1: "AAC Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest AAC basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Moneyline Movement | BetQL",
        h1: "A10 Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest A10 basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Moneyline Movement | BetQL",
        h1: "ACC Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest ACC basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Moneyline Movement | BetQL",
        h1: "ASUN Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest ASUN basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Moneyline Movement | BetQL",
        h1: "Big 12 Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Big 12 basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Moneyline Movement | BetQL",
        h1: "Big East Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Big East basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Moneyline Movement | BetQL",
        h1: "Big Sky Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Big Sky basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Moneyline Movement | BetQL",
        h1: "Big South Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Big South basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Moneyline Movement | BetQL",
        h1: "Big 10 Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Big 10 basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Moneyline Movement | BetQL",
        h1: "Big West Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Big West basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Moneyline Movement | BetQL",
        h1: "Colonial Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Colonial basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Moneyline Movement | BetQL",
        h1: "CUSA Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest CUSA basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Moneyline Movement | BetQL",
        h1: "Horizon League Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Horizon League basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Moneyline Movement | BetQL",
        h1: "Ivy League Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Ivy League basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Moneyline Movement | BetQL",
        h1: "MAC Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest MAC basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Moneyline Movement | BetQL",
        h1: "MEAC Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest MEAC basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Moneyline Movement | BetQL",
        h1: "Metro Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Metro basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Moneyline Movement | BetQL",
        h1: "MVC Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Missouri Valley basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Moneyline Movement | BetQL",
        h1: "MW Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Mountain West basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Moneyline Movement | BetQL",
        h1: "Northeast Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Northeast basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Moneyline Movement | BetQL",
        h1: "OVC Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Ohio Valley basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Moneyline Movement | BetQL",
        h1: "Pac 12 Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest PAC 12 basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Moneyline Movement | BetQL",
        h1: "Patriot League Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Patriot League basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Moneyline Movement | BetQL",
        h1: "SEC Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest SEC basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Moneyline Movement | BetQL",
        h1: "Southern Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Southern basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Moneyline Movement | BetQL",
        h1: "Southland Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Southland basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Moneyline Movement | BetQL",
        h1: "SWAC Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest SWAC basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Moneyline Movement | BetQL",
        h1: "Summit Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Summit basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Moneyline Movement | BetQL",
        h1: "Sun Belt Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Line Movement Moneyline Top 25 | BetQL",
        h1: "Top 25 Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest Top 25 basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Moneyline Movement | BetQL",
        h1: "WAC Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest WAC basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Moneyline Movement | BetQL",
        h1: "WCC Basketball - Money Line Movement",
        description:
          "Check out BetQL for the latest WCC basketball money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-lines": {
      seoTitle: "College Basketball 2nd Half Line Movement | BetQL",
      h1: "College Basketball 2nd Half Line Movement",
      description:
        "Check out BetQL for the latest College Basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Line Movement 2nd Half Spread All Conferences | BetQL",
        h1: "All College Basketball 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest College Basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 2nd Half Line Movement | BetQL",
        h1: "America East Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest America East basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 2nd Half Line Movement | BetQL",
        h1: "AAC Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest AAC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 2nd Half Line Movement | BetQL",
        h1: "A10 Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest A10 basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 2nd Half Line Movement | BetQL",
        h1: "ACC Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest ACC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 2nd Half Line Movement | BetQL",
        h1: "ASUN Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest ASUN basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 2nd Half Line Movement | BetQL",
        h1: "Big 12 Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Big 12 basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 2nd Half Line Movement | BetQL",
        h1: "Big East Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Big East basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 2nd Half Line Movement | BetQL",
        h1: "Big Sky Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Big Sky basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 2nd Half Line Movement | BetQL",
        h1: "Big South Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Big South basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 2nd Half Line Movement | BetQL",
        h1: "Big 10 Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Big 10 basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 2nd Half Line Movement | BetQL",
        h1: "Big West Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Big West basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 2nd Half Line Movement | BetQL",
        h1: "Colonial Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Colonial basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 2nd Half Line Movement | BetQL",
        h1: "CUSA Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest CUSA basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 2nd Half Line Movement | BetQL",
        h1: "Horizon League Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Horizon League basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 2nd Half Line Movement | BetQL",
        h1: "Ivy League Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Ivy League basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 2nd Half Line Movement | BetQL",
        h1: "MAC Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest MAC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 2nd Half Line Movement | BetQL",
        h1: "MEAC Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest MEAC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 2nd Half Line Movement | BetQL",
        h1: "Metro Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Metro basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 2nd Half Line Movement | BetQL",
        h1: "MVC Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 2nd Half Line Movement | BetQL",
        h1: "MW Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Mountain West basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 2nd Half Line Movement | BetQL",
        h1: "Northeast Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Northeast basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 2nd Half Line Movement | BetQL",
        h1: "OVC Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 2nd Half Line Movement | BetQL",
        h1: "Pac 12 Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest PAC 12 basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 2nd Half Line Movement | BetQL",
        h1: "Patriot League Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Patriot League basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 2nd Half Line Movement | BetQL",
        h1: "SEC Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest SEC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 2nd Half Line Movement | BetQL",
        h1: "Southern Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Southern basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 2nd Half Line Movement | BetQL",
        h1: "Southland Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Southland basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 2nd Half Line Movement | BetQL",
        h1: "SWAC Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest SWAC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 2nd Half Line Movement | BetQL",
        h1: "Summit Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Summit basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 2nd Half Line Movement | BetQL",
        h1: "Sun Belt Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Line Movement 2nd Half Spread Top 25 | BetQL",
        h1: "Top 25 Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest Top 25 basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball 2nd Half Line Movement | BetQL",
        h1: "WAC Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest WAC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 2nd Half Line Movement | BetQL",
        h1: "WCC Basketball - 2nd Half Line Movement",
        description:
          "Check out BetQL for the latest WCC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "second-half-moneylines": {
      seoTitle: "College Basketball 2nd Half Moneyline Movement | BetQL",
      h1: "College Basketball 2nd Half Money Line Movement",
      description:
        "Check out BetQL for the latest College Basketball 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Line Movement 2nd Half Moneyline All Conferences | BetQL",
        h1: "All College Basketball 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest College Basketball 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "America East Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest America East basketball 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "AAC Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest American basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "A10 Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest A10 basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "ACC Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest ACC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "ASUN Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest ASUN basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Big 12 Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest BIG 12 basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Big East Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big East basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Big Sky Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big Sky basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Big South Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big South basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Big 10 Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Big West Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Big West basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Colonial Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Colonial basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "CUSA Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest CUSA basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Horizon League Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Horizon League basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Ivy League Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Ivy League basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "MAC Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest MAC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "MEAC Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest MEAC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Metro Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Metro basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "MVC Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Missouri Valley basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "MW Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Mountain West basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Northeast Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Northeast basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "OVC Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Ohio Valley basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Pac 12 Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest PAC 12 basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Patriot League Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Patriot League basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "SEC Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest SEC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Southern Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Southern basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Southland Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Southland basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "SWAC Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest SWAC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Summit Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Summit basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "Sun Belt Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Line Movement 2nd Half Moneyline Top 25 | BetQL",
        h1: "Top 25 Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest Top 25 basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "NCAAB Line Movement 2nd Half Moneyline WAC | BetQL",
        h1: "WAC Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest WAC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball 2nd Half Moneyline Movement | BetQL",
        h1: "WCC Basketball - 2nd Half Money Line Movement",
        description:
          "Check out BetQL for the latest WCC basketball 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    spread: {
      all: {
        seoTitle: "NCAAB Line Movement Spread All Conferences | BetQL",
        h1: "All College Basketball Spread Line Movement",
        description:
          "Check out BetQL for the latest College Basketball spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Line Movement | BetQL",
        h1: "America East Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest America East basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Line Movement | BetQL",
        h1: "AAC Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest American basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Line Movement | BetQL",
        h1: "A10 Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest A10 basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Line Movement | BetQL",
        h1: "ACC Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest ACC basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Line Movement | BetQL",
        h1: "ASUN Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest ASUN basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Line Movement | BetQL",
        h1: "Big 12 Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest BIG 12 basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Line Movement | BetQL",
        h1: "Big East Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Big East basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Line Movement | BetQL",
        h1: "Big Sky Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Big Sky basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Line Movement | BetQL",
        h1: "Big South Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Big South basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Line Movement | BetQL",
        h1: "Big 10 Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Big basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Line Movement | BetQL",
        h1: "Big West Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Big West basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Line Movement | BetQL",
        h1: "Colonial Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Colonial basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Line Movement | BetQL",
        h1: "CUSA Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest CUSA basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Line Movement | BetQL",
        h1: "Horizon League Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Horizon League basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Line Movement | BetQL",
        h1: "Ivy League Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Ivy League basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Line Movement | BetQL",
        h1: "MAC Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest MAC basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Line Movement | BetQL",
        h1: "MEAC Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest MEAC basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Line Movement | BetQL",
        h1: "Metro Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Metro basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Line Movement | BetQL",
        h1: "MVC Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Missouri Valley basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Line Movement | BetQL",
        h1: "MW Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Mountain West basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Line Movement | BetQL",
        h1: "Northeast Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Northeast basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Line Movement | BetQL",
        h1: "OVC Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Ohio Valley basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Line Movement | BetQL",
        h1: "Pac 12 Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest PAC 12 basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Line Movement | BetQL",
        h1: "Patriot League Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Patriot League basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Line Movement | BetQL",
        h1: "SEC Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest SEC basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Line Movement | BetQL",
        h1: "Southern Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Southern basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Line Movement | BetQL",
        h1: "Southland Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Southland basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Line Movement | BetQL",
        h1: "SWAC Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest SWAC basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Line Movement | BetQL",
        h1: "Summit Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Summit basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Line Movement | BetQL",
        h1: "Sun Belt Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Line Movement Spread Top 25 | BetQL",
        h1: "Top 25 Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest Top 25 basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Line Movement | BetQL",
        h1: "WAC Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest WAC basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Line Movement | BetQL",
        h1: "WCC Basketball - Spread Line Movement",
        description:
          "Check out BetQL for the latest WCC basketball line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
    "totals-spread": {
      seoTitle: "College Basketball Over Under Line Movement | BetQL",
      h1: "College Basketball Over Under Line Movement",
      description:
        "Check out BetQL for the latest College Basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      all: {
        seoTitle: "NCAAB Line Movement Total All Conferences | BetQL",
        h1: "All College Basketball Over Under Line Movement",
        description:
          "Check out BetQL for the latest College Basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "america-east": {
        seoTitle: "America East Basketball Over Under Line Movement | BetQL",
        h1: "America East Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest America East basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      american: {
        seoTitle: "American Conference Basketball Over Under Line Movement | BetQL",
        h1: "AAC Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest American basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-10": {
        seoTitle: "A10 Basketball Over Under Line Movement | BetQL",
        h1: "A10 Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest A10 basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-coast": {
        seoTitle: "ACC Basketball Over Under Line Movement | BetQL",
        h1: "ACC Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest ACC basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "atlantic-sun": {
        seoTitle: "ASUN Basketball Over Under Line Movement | BetQL",
        h1: "ASUN Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest ASUN basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-12": {
        seoTitle: "Big 12 Basketball Over Under Line Movement | BetQL",
        h1: "Big 12 Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest BIG 12 basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-east": {
        seoTitle: "Big East Basketball Over Under Line Movement | BetQL",
        h1: "Big East Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big East basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-sky": {
        seoTitle: "Big Sky Basketball Over Under Line Movement | BetQL",
        h1: "Big Sky Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big Sky basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-south": {
        seoTitle: "Big South Basketball Over Under Line Movement | BetQL",
        h1: "Big South Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big South basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-ten": {
        seoTitle: "Big 10 Basketball Over Under Line Movement | BetQL",
        h1: "Big 10 Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "big-west": {
        seoTitle: "Big West Basketball Over Under Line Movement | BetQL",
        h1: "Big West Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Big West basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      colonial: {
        seoTitle: "Colonial Conference Basketball Over Under Line Movement | BetQL",
        h1: "Colonial Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Colonial basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "conference-usa": {
        seoTitle: "CUSA Basketball Over Under Line Movement | BetQL",
        h1: "CUSA Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest CUSA basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "horizon-league": {
        seoTitle: "Horizon League Basketball Over Under Line Movement | BetQL",
        h1: "Horizon League Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Horizon League basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ivy-league": {
        seoTitle: "Ivy League Basketball Over Under Line Movement | BetQL",
        h1: "Ivy League Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Ivy League basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      mac: {
        seoTitle: "MAC Basketball Over Under Line Movement | BetQL",
        h1: "MAC Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest MAC basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      meac: {
        seoTitle: "MEAC Basketball Over Under Line Movement | BetQL",
        h1: "MEAC Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest MEAC basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "metro-atlantic-athletic": {
        seoTitle: "MAAC Basketball Over Under Line Movement | BetQL",
        h1: "Metro Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Metro basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "missouri-valley": {
        seoTitle: "Missouri Valley Basketball Over Under Line Movement | BetQL",
        h1: "MVC Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Missouri Valley basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "mountain-west": {
        seoTitle: "Mountain West Basketball Over Under Line Movement | BetQL",
        h1: "MW Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Mountain West basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      northeast: {
        seoTitle: "Northeast Conference Basketball Over Under Line Movement | BetQL",
        h1: "Northeast Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Northeast basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "ohio-valley": {
        seoTitle: "Ohio Valley Basketball Over Under Line Movement | BetQL",
        h1: "OVC Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Ohio Valley basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "pac-12": {
        seoTitle: "Pac 12 Basketball Over Under Line Movement | BetQL",
        h1: "Pac 12 Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest PAC 12 basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "patriot-league": {
        seoTitle: "Patriot League Basketball Over Under Line Movement | BetQL",
        h1: "Patriot League Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Patriot League basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      sec: {
        seoTitle: "SEC Basketball Over Under Line Movement | BetQL",
        h1: "SEC Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest SEC basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southern: {
        seoTitle: "SoCon Basketball Over Under Line Movement | BetQL",
        h1: "Southern Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Southern basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      southland: {
        seoTitle: "Southland Conference Basketball Over Under Line Movement | BetQL",
        h1: "Southland Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Southland basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "southwestern-athletic": {
        seoTitle: "SWAC Basketball Over Under Line Movement | BetQL",
        h1: "SWAC Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest SWAC basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      summit: {
        seoTitle: "Summit League Basketball Over Under Line Movement | BetQL",
        h1: "Summit Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Summit basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "sun-belt": {
        seoTitle: "Sun Belt Basketball Over Under Line Movement | BetQL",
        h1: "Sun Belt Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Sun Belt basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "top-25": {
        seoTitle: "NCAAB Line Movement Total Top 25 | BetQL",
        h1: "Top 25 Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest Top 25 basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      wac: {
        seoTitle: "WAC Basketball Over Under Line Movement | BetQL",
        h1: "WAC Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest WAC basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
      "west-coast": {
        seoTitle: "WCC Basketball Over Under Line Movement | BetQL",
        h1: "WCC Basketball - Over Under Line Movement",
        description:
          "Check out BetQL for the latest WCC basketball over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
      },
    },
  },
};
